import { render, staticRenderFns } from "./NavigationSlider.vue?vue&type=template&id=746b347b&"
import script from "./NavigationSlider.ts?vue&type=script&lang=ts&"
export * from "./NavigationSlider.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationSlider.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports